import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Image } from 'src/app/core/models/image.model';

@Component({
  selector: 'app-comparaison',
  templateUrl: './comparaison.component.html',
  styleUrls: ['./comparaison.component.scss'],
})
export class ComparaisonComponent implements AfterViewInit {
  @ViewChild('comparaisonContainer') comparaisonContainer!: ElementRef;

  headers: string[] = this.translate.instant('home_comparaison.headers');
  themes: string[] = ['Dawn', 'Phantom'];
  activeTab: number = 1;

  mobileImage: Image = {
    url: 'https://cdn.shopify.com/s/files/1/0532/4226/5770/files/mobile_mockup_1.png?v=1677101897',
    alt: this.translate.instant('home_comparaison.mobile_image_alt'),
    crop: 'contain',
    lazy: false,
    breakpoints: ['120', '240', '360', '460'],
  };

  contents: Image[][] = [
    [
      {
        url: 'https://cdn.shopify.com/s/files/1/0532/4226/5770/files/Dawn-produit_450x.jpg?v=1677102251',
        alt: this.translate.instant('home_comparaison.dawn.0'),
        crop: 'contain',
        lazy: false,
        breakpoints: ['120', '240', '360', '460'],
      },
      {
        url: 'https://cdn.shopify.com/s/files/1/0532/4226/5770/files/Dawn-collection_450x.jpg?v=1677102251',
        alt: this.translate.instant('home_comparaison.dawn.1'),
        crop: 'contain',
        lazy: false,
        breakpoints: ['120', '240', '360', '460'],
      },
      {
        url: 'https://cdn.shopify.com/s/files/1/0532/4226/5770/files/Dawn-minicart_450x.jpg?v=1677102251',
        alt: this.translate.instant('home_comparaison.dawn.2'),
        crop: 'contain',
        lazy: false,
        breakpoints: ['120', '240', '360', '460'],
      },
    ],
    [
      {
        url: 'https://cdn.shopify.com/s/files/1/0532/4226/5770/files/Phantom-produit_450x.jpg?v=1677102251',
        alt: this.translate.instant('home_comparaison.phantom.0'),
        crop: 'contain',
        lazy: false,
        breakpoints: ['120', '240', '360', '460'],
      },
      {
        url: 'https://cdn.shopify.com/s/files/1/0532/4226/5770/files/Phantom-Collection_450x.jpg?v=1677102251',
        alt: this.translate.instant('home_comparaison.phantom.1'),
        crop: 'contain',
        lazy: false,
        breakpoints: ['120', '240', '360', '460'],
      },
      {
        url: 'https://cdn.shopify.com/s/files/1/0532/4226/5770/files/Phantom-minicart_450x.jpg?v=1677102251',
        alt: this.translate.instant('home_comparaison.phantom.2'),
        crop: 'contain',
        lazy: false,
        breakpoints: ['120', '240', '360', '460'],
      },
    ],
  ];

  constructor(private translate: TranslateService) {}

  ngAfterViewInit(): void {
    const arrowPrev = this.comparaisonContainer.nativeElement.querySelector(
      'i.fa-arrow-left'
    ) as HTMLElement;
    const arrowNext = document.querySelector('i.fa-arrow-right') as HTMLElement;

    let actual = parseInt(
      document.querySelector('[data-actual]')?.getAttribute('data-actual') ||
        '0',
      10
    );
    const max = parseInt(
      document.querySelector('[data-max]')?.getAttribute('data-max') || '2',
      10
    );

    arrowPrev.addEventListener('click', () => {
      actual = actual > 0 ? actual - 1 : max;
      this.changeContent(actual);
    });

    arrowNext.addEventListener('click', () => {
      actual = actual < max ? actual + 1 : 0;
      this.changeContent(actual);
    });
  }

  changeContent(actual: number): void {
    const headers = document.querySelectorAll('.prev_next__header.active');
    headers.forEach((header) => {
      header.classList.remove('active');
    });

    const contents = document.querySelectorAll('.prev_next__content.active');
    contents.forEach((content) => {
      content.classList.remove('active');
    });

    const activeHeaders = document.querySelectorAll(`[data-tab="${actual}"]`);
    activeHeaders.forEach((header) => {
      header.classList.add('active');
    });

    const activeContents = document.querySelectorAll(`[data-tab="${actual}"]`);
    activeContents.forEach((content) => {
      content.classList.add('active');
      const videoElement = content.querySelector(
        'video'
      ) as HTMLVideoElement | null;
      if (videoElement && videoElement.dataset['src']) {
        videoElement.src = videoElement.dataset['src'];
      }
    });
  }
}
